import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import { OverviewSingle } from 'src/sections/overview-single';

export const SummaryOverview = ({ data }) => {
  // Define summary items to avoid repetitive code
  const summaryItems = useMemo(() => [
    { title: 'Km trong tháng', key: 'kilometers', icon: 'iconly-glass-tick.svg' },
    { title: 'Nhiên liệu (lít)', key: 'quantity', icon: 'iconly-glass-chart.svg' },
    { title: 'Giờ thực tế', key: 'working', icon: 'iconly-glass-activity.svg' },
    { title: 'Giờ trên lịch', key: 'hours', icon: 'iconly-glass-calendar.svg' },
    { title: 'T2-T6', key: 'days_t2-t6', icon: 'iconly-glass-info.svg' },
    { title: 'T7-CN', key: 'days_t7-cn', icon: 'iconly-glass-clock.svg' },
    { title: 'Ngoài giờ', key: 'days_over', icon: 'iconly-glass-discount.svg' },
  ], []);

  return (
    <Box component="main" sx={{ flexGrow: 1, py: 1, px: 0 }}>
      <Grid container disableEqualOverflow spacing={{ xs: 1, lg: 2 }}>
        {summaryItems.map((item) => (
          <Grid key={item.key} xs={12} md={3}>
            <OverviewSingle
              title={item.title}
              value={data[item.key] ?? '0'}
              imgIcon={`/assets/iconly/${item.icon}`}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
